import React from "react";
import PropTypes from "prop-types";

export const List = ({ children }) => {
  const listStyle = () => ({
    listStyle: "inside",
    textAlign: "left",
  });

  return <ul style={listStyle()}>{children}</ul>;
};

List.propTypes = {
  children: PropTypes.node.isRequired,
};

export default List;
